export default __webpack_public_path__ + "static/media/untied-white-logo.b72bfcdd.png";